export default __webpack_public_path__ + "static/media/maintenance.78a68d93.svg";